import { useNavigate, useLocation } from "react-router-dom";

import { ChevronLeft } from "@assets";
import { Row } from "@components/Flex";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body } from "@components/Typography";
import { isValidElement } from "react";
import { styles } from "./styles";
import { PageHeaderProps } from "./types";

export const PageHeader = ({ title, rightHeader }: PageHeaderProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const canGoBack = window.history.length > 1 && location;

  if (!title) return null;

  const header = (() => {
    if (isValidElement(title)) return <div style={styles.header}>{title}</div>;
    return <Body style={styles.text}>{title}</Body>;
  })();

  return (
    <>
      <Row>
        {canGoBack ? (
          <div onClick={() => navigate(-1)}>
            <ChevronLeft />
          </div>
        ) : (
          <div style={styles.placeholder} />
        )}
        {header}
        {rightHeader ? rightHeader : <div style={styles.placeholder} />}
      </Row>
      <Spacing size={SpacingSizes.M} />
    </>
  );
};
